const texts = {
  headerTitle: {
    create: 'Create Track',
    edit: 'Edit Track',
  },
  field: {
    name: 'Name',
    type: 'Track Type',
    difficulty: 'Difficulty',
    location: 'Location',
    equipment: 'Equipment',
  },
  emptyValue: 'No equipment set',
  addNewTrack: 'Create Track',
  saveChanges: 'Save Changes',
  cancel: 'Cancel',
  trackSaved: 'Track saved.',
  trackSaveError: 'Error saving track.',
  trackIdLabel: 'Track ID',
  validation: {
    requiredField: 'Required field.',
    programRequired: 'Select at least one program.',
  },
  difficultyLevel: {
    BEGINNER: 'Beginner',
    INTERMEDIATE: 'Intermediate',
    ADVANCED: 'Advanced',
  },
  locationType: {
    HOME: 'Home',
    GYM: 'Gym',
  },
  trackType: {
    STANDARD: 'Standard',
    HYROX: 'Hyrox',
  },
  missingProgram: 'Missing program',
};

export default texts;
